module.exports = __webpack_public_path__ + "img/external.f1576eb9.jpg";